module.exports = ".modal-content-wrapper {\n  margin-top: 10vh;\n  display: block; }\n\n.list-group .list-group-item.active {\n  background: rgba(0, 0, 0, 0.01);\n  font-weight: bold;\n  border-color: #eee; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/layouts/components/partials/tenants-modal/tenants-modal.component.scss
// module id = ./libs/chassis-core/src/app/layouts/components/partials/tenants-modal/tenants-modal.component.scss
// module chunks = main